import React, { useState, useEffect, useRef, useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';

import './style.scss';
import './style.darkmode.scss';
import { deleteUserListUser, getUserListUsers, getUserLists, removeUserLists, resetUserListUsers, resetUserLists, setActiveUserList, setUserListUserPage, setUserListsPage, updateUserLists } from '../../../redux/actions/userLists';
import { List, ListItem, ListItemText, Grid, Container, ListItemButton, TextField, CircularProgress, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Menu, MenuItem, Radio, Divider, InputAdornment, useMediaQuery } from '@mui/material';
import Create from './Create';
import { useTheme } from '@mui/material/styles';
import ActionTypes from '../../../redux/constants/action-types';
import User from './User';
import { Virtuoso, VirtuosoGrid } from 'react-virtuoso';
import { setAlert } from '../../../redux/actions';
import useDidMountEffect from '../../utils/useDidMountEffect';
import AddUsers from './AddUsers';
import useDebounce from '../../utils/useDebounceV2';
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { useHistory, useLocation } from 'react-router';
import { ROLES } from '../../utils/constants';
import PageHeader from '../PageHeader';

const LIST_PER_PAGE = 30;
const USERS_PER_PAGE = 60;
const DEBOUNCE_DELAY = 800;
const virtuosoStyle = { height: 'calc(100vh - 190px)', overflowX: 'hidden' };

const UserLists = ({
    userListsRdx,
    activeUserListRdx,
    listBusyRdx,
    membersBusyRdx,
    activeUserListUsersRdx,
    userListsPageRdx,
    usersPageRdx,
    userListsHasMoreRdx,
    usersHasMoreRdx,
    userListsTotalRdx,
    userListUsersTotalRdx
}) => {
    const isMobile = useMediaQuery('(max-width: 899px)');

    const theme = useTheme();
    const [keyword, setKeyword] = useState('');
    const [usersKeyword, setUsersKeyword] = useState('');
    const [showNewForm, setShowNewForm] = useState(false);
    const [showDeleteUserConfirm, setShowDeleteUserConfirm] = useState(false);
    const [activeUser, setActiveUser] = useState({});
    const [showListMenu, setShowListMenu] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [userListSort, setUserListSort] = useState('name');
    const [order, setOrder] = useState('desc');
    const [showConfirmDeleteList, setShowConfirmDeleteList] = useState(false);
    const [editList, setEditList] = useState({});
    const [showFollowers, setShowFollowers] = useState(false);

    const dispatch = useDispatch();
    const usersRef = useRef();
    const history = useHistory();
    const userInformation = JSON.parse(localStorage.getItem('user'));
    const location = useLocation();

    const sourceState = location.state;

    const handleActiveUserList = (payload) => {
        dispatch(setActiveUserList(payload));
    };

    const handleKeywordChange = e => {
        const value = e.target.value;
        setKeyword(value);
    };

    const getUserCollection = () => {
        dispatch(getUserListUsers({
            id: activeUserListRdx.id,
            page: 1,
            action: ActionTypes.SET_USER_LIST_USERS,
            per_page: USERS_PER_PAGE,
            kw: usersKeyword
        }));
    };

    useEffect(() => {
        if (userInformation.role === ROLES.SU) {
            history.push('/home');
        }
        return () => {
            dispatch(resetUserLists());
        };
    }, []);

    useEffect(() => {
        if (activeUserListRdx && Object.keys(activeUserListRdx).length > 0) {
            dispatch(resetUserListUsers());
            getUserCollection();
        }
    }, [activeUserListRdx]);

    const handleNewList = () => {
        setShowNewForm(true);
    };

    const handleListEnd = () => {
        if (listBusyRdx) return;

        if (userListsHasMoreRdx) {
            dispatch(setUserListsPage(userListsPageRdx + 1));
        }
    };

    const getLists = () => {
        dispatch(getUserLists({
            page: userListsPageRdx,
            action: userListsPageRdx > 1
                ? ActionTypes.APPEND_USER_LISTS
                : ActionTypes.SET_USER_LISTS,
            per_page: LIST_PER_PAGE,
            order: order,
            sort: userListSort,
            kw: keyword
        }));
    };

    useEffect(() => {
        if (userListsPageRdx) {
            getLists();
        }
    }, [userListsPageRdx]);

    const debounceUserListSearch = useDebounce(() => {
        dispatch(resetUserLists());
        getLists();
    }, [DEBOUNCE_DELAY]);

    useDidMountEffect(() => {
        debounceUserListSearch();
    }, [keyword]);

    const debounceUsersSearch = useDebounce(() => {
        dispatch(resetUserListUsers());
        getUserCollection();
    }, [DEBOUNCE_DELAY]);

    useDidMountEffect(() => {
        debounceUsersSearch();
    }, [usersKeyword]);


    useEffect(() => {
        if (usersPageRdx && activeUserListRdx && Object.keys(activeUserListRdx).length > 0) {
            if (activeUserListUsersRdx && activeUserListUsersRdx.length > 0) {
                dispatch(getUserListUsers({
                    id: activeUserListRdx.id,
                    page: usersPageRdx,
                    action: ActionTypes.APPEND_USER_LIST_USERS,
                    per_page: USERS_PER_PAGE,
                    keyword
                }));
            } else {
                dispatch(getUserListUsers({
                    id: activeUserListRdx.id,
                    page: usersPageRdx,
                    action: ActionTypes.SET_USER_LIST_USERS,
                    per_page: USERS_PER_PAGE,
                    keyword
                }));
            }
        }
    }, [usersPageRdx]);

    const handleUsersKeywordChange = e => {
        setUsersKeyword(e.target.value);
    };

    const handleShowDeleteUserConfirm = (user) => {
        setActiveUser(user);
        setShowDeleteUserConfirm(true);
    };

    const handleDeleteUserConfirmation = () => {
        setActiveUser({});
        setShowDeleteUserConfirm(false);
    };

    const handleRemoveUser = () => {
        axios.delete('/api/user-list-users', {
            data: {
                list_id: activeUserListRdx.id,
                user_id: activeUser.user_id
            }
        })
            .then(response => {
                if (response.data.success) {
                    dispatch(setAlert({
                        show: true,
                        type: 'success',
                        body: 'User successfully removed'
                    }));

                    dispatch(deleteUserListUser(activeUser.id));
                    dispatch(updateUserLists(response.data.user_list));
                    handleDeleteUserConfirmation();
                } else {
                    dispatch(setAlert({
                        show: true,
                        type: 'error',
                        body: 'User already removed from list'
                    }));
                }
            })
            .catch(error => {
                console.error({ error });
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Failed to remove user from list'
                }));
            });
    };


    const handleUsersEnd = () => {
        if (membersBusyRdx) return;
        if (usersHasMoreRdx) {
            dispatch(setUserListUserPage(usersPageRdx + 1));
        }
    };

    const handleOpenUserListOption = e => {
        setAnchorEl(e.currentTarget);
        setShowListMenu(true);
    };

    const handleUserListSortChange = e => {
        setUserListSort(e.target.value);
    };

    const handleUserOrderChange = e => {
        setOrder(e.target.value);
    };

    useDidMountEffect(() => {
        dispatch(resetUserLists());
        getLists();
    }, [order, userListSort]);

    const handleSetShowConfirmDeleteList = () => {
        setShowConfirmDeleteList(showConfirmDeleteList => !showConfirmDeleteList);
    };

    const handleRemoveList = () => {
        axios.delete(`/api/user-lists/${activeUserListRdx.id}`)
            .then(response => {
                setShowConfirmDeleteList(false);
                dispatch(removeUserLists(activeUserListRdx.id));
                dispatch(setActiveUserList({}));
                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: 'User list successfully removed'
                }));
                dispatch(resetUserListUsers());
            })
            .catch(error => {
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Unable to remove user list'
                }));
            });
    };

    const handleEditList = () => {
        setEditList(activeUserListRdx);
    };

    useEffect(() => {
        if (editList && Object.keys(editList).length > 0) {
            setShowNewForm(true);
        }
    }, [editList]);

    const handleAddFollowers = () => {
        setShowFollowers(showFollowers => !showFollowers);
    };

    const handleClearKeyword = () => {
        setKeyword('');
    };

    const handleClearUsersKeyword = () => {
        setUsersKeyword('');
    };

    const handleBack = () => {
        dispatch(setActiveUserList({}));
    };

    const showNewOrEditForm = (value) => {
        setShowNewForm(value);

        if (!value) {
            setEditList(value);
        }
    };

    const onBack = () => {
        history.push({
            pathname: '/messages/newmessage',
            state: {
                from: 'user-lists',
                open: 'broadcast',
                selected: sourceState.selected
            }
        });
    };

    return <Container
        className='user-lists'
        style={{ backgroundColor: theme.palette.background.default, padding: 0, margin: 0 }}
    >
        {/* <div style={{
            paddingLeft: 12
        }}>
            <PageHeader
                title="User Lists"
                backable={
                    // Desktop
                    (sourceState && !isMobile)
                    ||
                    //   mobile
                    (sourceState && (activeUserListRdx && Object.keys(activeUserListRdx).length === 0) && isMobile)
                }
                onBack={onBack}
            />
        </div> */}

        <div style={{
            display: 'flex',
            gap: 8,
            height: '100vh'
        }}>
            <div
                className={`user-lists__sidebar${activeUserListRdx && Object.keys(activeUserListRdx).length > 0 ? ' user-lists__sidebar-active' : ' user-lists__sidebar-no_active'}`}
            >
                <div style={{ paddingLeft: 12 }}>
                    <PageHeader
                        title="User Lists"
                        backable={
                            // Desktop
                            (sourceState && !isMobile)
                            ||
                            //   mobile
                            (sourceState && (activeUserListRdx && Object.keys(activeUserListRdx).length === 0) && isMobile)
                        }
                        onBack={onBack}
                        closable={false}
                    />
                </div>

                <div
                    className="sidebar__search"
                    style={{ backgroundColor: theme.palette.background.default }}
                >
                    <div className="search-container">
                        <TextField
                            id="keyword"
                            label="Search"
                            value={keyword}
                            onChange={handleKeywordChange}
                            size='small'
                            InputProps={{
                                endAdornment: (
                                    !!keyword
                                        ? <IconButton
                                            aria-label="Clear text"
                                            onClick={handleClearKeyword}
                                            edge="end"
                                        >
                                            <i
                                                style={{ color: '#0097fe' }}
                                                className="fal fa-times search-clear-icon"
                                            ></i>
                                        </IconButton>
                                        : ''
                                ),
                                startAdornment: <InputAdornment position="start">
                                    <i className="fa-regular fa-magnifying-glass"></i>
                                </InputAdornment>,
                            }}
                        />
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <OverlayTrigger overlay={<Tooltip placement="bottom" className="in" id="tooltip-bottom">Sort User Lists</Tooltip>}>
                            <IconButton
                                aria-label="New User List"
                                onClick={handleOpenUserListOption}
                                aria-controls={showListMenu ? 'basic-menu' : undefined}
                                aria-haspopup="true"
                                aria-expanded={showListMenu ? 'true' : undefined}
                            >
                                <i className="fa-solid fa-bars-sort icon"></i>
                            </IconButton>
                        </OverlayTrigger>

                        <Menu
                            anchorEl={anchorEl}
                            id="list-options"
                            open={showListMenu}
                            onClose={() => setShowListMenu(false)}
                            MenuListProps={{
                                'aria-labelledby': 'list-options',
                            }}
                            dense
                            sx={{
                                zIndex: 999999
                            }}
                        >
                            <MenuItem onClick={() => { }}>
                                <Radio
                                    value='created_at'
                                    checked={userListSort === 'created_at'}
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'created_at' }}
                                    onChange={handleUserListSortChange}
                                /> Recent
                            </MenuItem>
                            <MenuItem onClick={() => { }}>
                                <Radio
                                    value='name'
                                    checked={userListSort === 'name'}
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'name' }}
                                    onChange={handleUserListSortChange}
                                /> Name
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => { }}>
                                <Radio
                                    value='asc'
                                    checked={order === 'asc'}
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'asc' }}
                                    onChange={handleUserOrderChange}
                                /> Ascending
                            </MenuItem>
                            <MenuItem onClick={() => { }}>
                                <Radio
                                    value='desc'
                                    checked={order === 'desc'}
                                    name="radio-buttons"
                                    inputProps={{ 'aria-label': 'desc' }}
                                    onChange={handleUserOrderChange}
                                /> Descending
                            </MenuItem>
                        </Menu>
                    </div>
                    <div>
                        <OverlayTrigger overlay={<Tooltip placement="bottom" className="in" id="tooltip-bottom">Add New User List</Tooltip>}>
                            <IconButton
                                aria-label="New User List"
                                onClick={handleNewList}
                            >
                                <i className="fa-sharp fa-solid fa-plus icon"></i>
                            </IconButton>
                        </OverlayTrigger>
                    </div>
                </div>

                <Virtuoso
                    id="user-lists__container"
                    style={{
                        height: `${isMobile ? 'calc(100vh - 200px)' : 'calc(100vh - 120px)'}`,
                        overflowX: 'hidden'
                    }}
                    totalCount={userListsTotalRdx}
                    data={userListsRdx}
                    atBottomThreshold='50'
                    endReached={handleListEnd}
                    itemContent={(index, uList) => <ListItem
                        key={uList.id}
                        className={`user-lists__item ${activeUserListRdx && activeUserListRdx.id == uList.id ? `active` : ''}`}
                        style={{
                            overflowX: 'break-word'
                        }}
                        disableGutters
                    >
                        <ListItemButton
                            onClick={() => handleActiveUserList(uList)}
                            divider
                        >
                            <ListItemText
                                sx={{ margin: 0 }}
                                primary={uList.name}
                            />
                            <ListItemText
                                id="user-count"
                                sx={{ margin: 0 }}
                                primary={`${uList.user_count} ${uList.user_count === 1 ? 'user' : 'users'}`}
                            />
                        </ListItemButton>
                    </ListItem>}
                />
            </div>

            <div
                className='user-lists__content'
            >
                <PageHeader
                    title=""
                    backable={false}
                />
                <div
                    className='content__actions'
                    style={{ backgroundColor: theme.palette.background.default }}
                >
                    <div className='content__actions-mobile'>
                        <IconButton
                            className="clear-text-icon-button"
                            aria-label="clear text"
                            onClick={handleBack}
                        >
                            <i className="fa-regular fa-chevron-left"></i>
                        </IconButton>
                        <strong className='content__actions-title' title={activeUserListRdx.name}>{activeUserListRdx.name}</strong>
                    </div>
                    {activeUserListRdx && Object.keys(activeUserListRdx).length > 0 && <div className='content__actions-wrapper'>
                        <div className="user__search">
                            <TextField
                                id="usersKeyword"
                                label="Search"
                                value={usersKeyword}
                                onChange={handleUsersKeywordChange}
                                size='small'
                                // disabled={activeUserListUsersRdx.length <= 0}
                                InputProps={{
                                    endAdornment: (
                                        !!usersKeyword
                                            ? <IconButton
                                                aria-label="clear text"
                                                onClick={handleClearUsersKeyword}
                                                edge="end"
                                            >
                                                <i style={{ color: '#0097fe' }} className="fal fa-times search-clear-icon"></i>
                                            </IconButton>
                                            : ''
                                    ),
                                    startAdornment: <InputAdornment position="start">
                                        <i className="fa-regular fa-magnifying-glass"></i>
                                    </InputAdornment>,
                                }}
                            />
                        </div>
                        <div>
                            <OverlayTrigger overlay={<Tooltip placement="bottom" className="in" id="tooltip-bottom">Add User</Tooltip>}>
                                <IconButton
                                    aria-label="Add User"
                                    onClick={handleAddFollowers}
                                >
                                    <i className="fa-regular fa-users-medical icon"></i>
                                </IconButton>
                            </OverlayTrigger>
                        </div>
                        <div>
                            <OverlayTrigger overlay={<Tooltip placement="bottom" className="in" id="tooltip-bottom">Rename User List</Tooltip>}>
                                <IconButton
                                    aria-label="Rename User List"
                                    onClick={handleEditList}
                                >
                                    <i className="fa-sharp fa-solid fa-pen-to-square icon"></i>
                                </IconButton>
                            </OverlayTrigger>
                        </div>
                        <div>
                            <OverlayTrigger overlay={<Tooltip placement="bottom" className="in" id="tooltip-bottom">Delete User List</Tooltip>}>
                                <IconButton
                                    aria-label="Delete List"
                                    onClick={handleSetShowConfirmDeleteList}
                                >
                                    <i className="fa-sharp fa-solid fa-trash icon"></i>
                                </IconButton>
                            </OverlayTrigger>
                        </div>
                    </div>}
                </div>
                <div className="content__users">
                    {
                        activeUserListRdx && Object.keys(activeUserListRdx).length > 0 && activeUserListUsersRdx && Object.keys(activeUserListUsersRdx).length > 0 && <VirtuosoGrid
                            style={{
                                height: `${isMobile ? 'calc(100vh - 220px)' : 'calc(100vh - 120px)'}`,
                                overflowX: 'hidden'
                            }}
                            totalCount={userListUsersTotalRdx}
                            ref={usersRef}
                            endReached={handleUsersEnd}
                            itemClassName='user__card'
                            data={activeUserListUsersRdx}
                            itemContent={(index, user) => <React.Fragment>
                                <User
                                    key={user.id}
                                    user={user}
                                    onDelete={handleShowDeleteUserConfirm}
                                    active={activeUser}
                                />
                            </React.Fragment>}
                        />
                    }

                    {
                        !activeUserListRdx || Object.keys(activeUserListRdx).length == 0
                            ? <div className='no-active'>
                                Select any list or create a list
                            </div>
                            : null
                    }
                </div>
                {
                    membersBusyRdx && <div style={{
                        display: 'flex',
                        alignSelf: 'center',
                        justifyContent: 'center',
                        flex: 1,
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        width: '100%',
                        padding: '8px'
                    }}>
                        <CircularProgress size={30} />
                    </div>
                }

                {!membersBusyRdx && activeUserListUsersRdx && activeUserListUsersRdx.length <= 0 && activeUserListRdx && Object.keys(activeUserListRdx).length > 0 && <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexGrow: 1
                    }}>No user found</div>}
            </div>
        </div>

        {showNewForm && <Create
            show={showNewForm}
            // !!! setEditList && setShowNewForm
            setShow={showNewOrEditForm}
            edit={editList}
            setEdit={setEditList}
        />}

        {
            showFollowers && activeUserListRdx && Object.keys(activeUserListRdx).length > 0 && <AddUsers
                show={showFollowers}
                setShow={setShowFollowers}
            />
        }

        {showDeleteUserConfirm && <Dialog
            open={showDeleteUserConfirm}
            keepMounted
            onClose={handleDeleteUserConfirmation}
            aria-describedby="remove-user-confirm"
        >
            <DialogTitle>{"Are you sure?"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="remove-user-confirm">
                    This will remove user from the list. You can add them back when needed.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDeleteUserConfirmation}>Cancel</Button>
                <Button onClick={handleRemoveUser}>Yes, remove user</Button>
            </DialogActions>
        </Dialog>}

        {showConfirmDeleteList && <Dialog
            open={showConfirmDeleteList}
            keepMounted
            onClose={handleSetShowConfirmDeleteList}
            aria-describedby="remove-list-confirm"
        >
            <DialogTitle>{"Are you sure?"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="remove-list-confirm">
                    This will delete the list.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSetShowConfirmDeleteList}>Cancel</Button>
                <Button onClick={handleRemoveList}>Yes, remove user list</Button>
            </DialogActions>
        </Dialog>}
    </Container>;
};

const mapStateToProps = (state) => ({
    userListsRdx: state.userLists.userLists,
    activeUserListRdx: state.userLists.activeUserList,
    activeUserListUsersRdx: state.userLists.users,
    listBusyRdx: state.userLists.busy,
    membersBusyRdx: state.userLists.usersBusy,
    userListsPageRdx: state.userLists.userListsPage,
    usersPageRdx: state.userLists.usersPage,
    userListsHasMoreRdx: state.userLists.userListsHasMore,
    usersHasMoreRdx: state.userLists.usersHasMore,
    userListsTotalRdx: state.userLists.userListsTotal,
    userListUsersTotalRdx: state.userLists.userListUsersTotal,
});

export default connect(mapStateToProps)(UserLists);